// extracted by mini-css-extract-plugin
module.exports = {"customList":"_3WQ-HRmWu4tMZJbT0YwaMB _3FaVkL6BK8xFzNbUgnDLME","suggestionItem":"_1dHUNglbaO6QnxgILfFjZI"};